var _desc, _defs, _polygon, _polygon2, _path, _g, _use, _path2, _path3, _path4, _path5, _polygon3, _polygon4, _polygon5, _path6, _polygon6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "22px",
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "crowns") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,10.3791848 L21.6864443,13 L14,13 L14,6 C17.7134713,6 21.0703125,7.64216732 23,10.3791848 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26,7.67055375 L22.9551606,18 L5.04483938,18 L2,7.67055375 L4.05158827,6.89106066 C4.97975333,8.66130931 6.75446096,9.7007039 8.20352638,9.8793994 L9.05028088,9.8793994 C10.9227236,9.58714234 12.3228154,6.72864865 12.8929013,4 L15.1073107,4 C15.6771846,6.72864865 17.0774884,9.58714234 18.9497191,9.8793994 L19.7964736,9.8793994 C21.245539,9.7007039 23.0202467,8.66130931 23.9484117,6.89106066 L26,7.67055375 Z",
    id: "path-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "App-Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rankings",
    transform: "translate(-84.000000, -344.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(0.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#1",
    transform: "translate(18.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crowns",
    transform: "translate(66.000000, 104.000000)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8B64C",
    points: "5 18 5 22 23 22 23 18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.049999997,
    points: "14 18 23 18 23 22 14 22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,10.3791848 L21.6864443,13 L6.31355573,13 L5,10.3791848 C6.92968751,7.64216732 10.2865287,6 14,6 C17.7134713,6 21.0703125,7.64216732 23,10.3791848 Z",
    id: "Path",
    fill: "#FF7058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FF7058",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#000000",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFD15C",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.51,
    fill: "url(#linearGradient-2)",
    style: {
      mixBlendMode: "overlay"
    },
    xlinkHref: "#path-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7.67055375 L22.9551606,18 L14,18 L14,4 L15.1070987,4 C15.6771846,6.72864865 17.0772764,9.58714234 18.9497191,9.8793994 L19.7964736,9.8793994 C21.245539,9.7007039 23.0202467,8.66130931 23.9484117,6.89106066 L26,7.67055375 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.049999997
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52747253,9 C1.16414835,9 0,7.87847222 0,6.5 C0,5.12152778 1.16414835,4 2.52747253,4 C3.8907967,4 5,5.12152778 5,6.5 C5,7.87847222 3.8907967,9 2.52747253,9 Z",
    id: "Path",
    fill: "#F8B64C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4725275,9 C24.1092033,9 23,7.87847222 23,6.5 C23,5.12152778 24.1092033,4 25.4725275,4 C26.8358516,4 28,5.12152778 28,6.5 C28,7.87847222 26.8358516,9 25.4725275,9 Z",
    id: "Path",
    fill: "#EBAC48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14,0 C12.3398437,0 11,1.33984373 11,3 C11,4.65989587 12.3398437,6 14,6 C15.6601563,6 17,4.65989587 17,3 C17,1.33984373 15.6601563,0 14,0 Z",
    id: "Path",
    fill: "#F8B64C"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF7058",
    points: "14 10 11 13 14 16 17 13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E5644F",
    points: "19 13 20 14 19 15 18 14"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF7058",
    points: "9 13 10 14 9 15 8 14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14,6 L14,0 C15.6601563,0 17,1.33984373 17,3 C17,4.65989587 15.6601563,6 14,6 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.049999997
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6654F",
    points: "17 13 14 16 14 10"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrown);
export default __webpack_public_path__ + "static/media/icon-crown.0e212330.svg";
export { ForwardRef as ReactComponent };